import _default from './Label';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Label/index.js
// module id = 121
// module chunks = 0